import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

export default function CheckoutSuccess() {
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const { user } = useAuth();
  const [order, setOrder]   = useState(null);
  const [guestEmail, setGuestEmail] = useState('');
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) { setError('Invalid checkout session.'); setLoading(false); return; }

    api.post('/payments/confirm', { session_id: sessionId })
      .then(r => {
        setOrder(r.data);
        clearCart();
        // Grab guest email from saved form
        try {
          const saved = sessionStorage.getItem('sm_checkout_form');
          if (saved) setGuestEmail(JSON.parse(saved).email || '');
        } catch (_) {}
        sessionStorage.removeItem('sm_checkout_form');
      })
      .catch(e => setError(e.response?.data?.error || 'Could not confirm order. Please contact support@styleme.club'))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  if (loading) return (
    <div className="container" style={{ textAlign: 'center', padding: 80 }}>
      <div className="spinner" />
      <p style={{ marginTop: 16, color: '#6b7280' }}>Confirming your payment…</p>
    </div>
  );

  if (error) return (
    <div className="container" style={{ maxWidth: 480, textAlign: 'center', padding: 60 }}>
      <div style={{ fontSize: 52, marginBottom: 16 }}>⚠️</div>
      <h2>Something went wrong</h2>
      <p style={{ color: '#6b7280', marginBottom: 24 }}>{error}</p>
      <Link to="/shop" className="btn btn-primary">Back to Shop</Link>
    </div>
  );

  return (
    <div className="container" style={{ maxWidth: 520, margin: '0 auto', padding: '60px 16px' }}>
      <div style={{ textAlign: 'center', marginBottom: 36 }}>
        <div style={{ fontSize: 72, marginBottom: 16 }}>🎉</div>
        <h1 style={{ marginBottom: 8 }}>Payment Successful!</h1>
        <p style={{ color: '#6b7280', fontSize: 15 }}>
          Order #{order?.id} — Total: <strong>${order?.total?.toFixed(2)}</strong>
        </p>
        <p style={{ color: '#6b7280', fontSize: 14 }}>
          We'll send shipping updates to your email.
        </p>
      </div>

      {order?.items?.length > 0 && (
        <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e5e7eb', padding: 20, marginBottom: 24 }}>
          <h3 style={{ marginBottom: 14 }}>Items Ordered</h3>
          {order.items.map(item => (
            <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f3f4f6', fontSize: 14 }}>
              <span>{item.product_name} × {item.quantity}</span>
              <span style={{ fontWeight: 600 }}>${item.total.toFixed(2)}</span>
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
        {order?.id && (
          user
            ? <Link to={`/orders/${order.id}`} className="btn btn-primary">View My Order</Link>
            : <Link to={`/track`} className="btn btn-primary">Track My Order</Link>
        )}
        <Link to="/shop" className="btn btn-outline">Continue Shopping</Link>
      </div>
    </div>
  );
}
